import googleAnalytics from 'lib/GoogleAnalytics';
import eventLogger from 'lib/EventLogger';
import { EventType, Features, SourcePages, ViewTypes } from 'lib/EventSchema';
import * as _ from 'lodash-es';
import { EventData } from 'lib/EventLogger/Event';

export function trackPaidWelcome(): void {
  googleAnalytics.event({
    category: 'paid_flow',
    action: 'survey_welcome',
    label: '',
  });
}

export function trackPaidMakeModelSearch(make?: string, model?: string): void {
  googleAnalytics.event({
    category: 'paid_flow',
    action: 'search_make_model_button',
    label: `${make} ${model}`,
  });

  eventLogger.log({
    event_type: EventType.action,
    engagement_type: 'search_make_model_button',
    feature: Features.PaidFlow,
    source_page: SourcePages.PaidLandingTest,
    event_context: {
      channel: 'paid',
    },
  });
}

export function trackPaidBodyStyleSearch(style: string): void {
  googleAnalytics.event({
    category: 'paid_flow',
    action: 'search_body_style_button',
    label: style,
  });

  eventLogger.log({
    event_type: EventType.action,
    engagement_type: 'search_body_style_button',
    feature: Features.PaidFlow,
    source_page: SourcePages.PaidLandingTest,
    event_context: {
      channel: 'paid',
    },
  });
}

export function trackPaidPriceSearch(min: number, max: number): void {
  googleAnalytics.event({
    category: 'paid_flow',
    action: 'search_price_button',
    label: [min, max],
  });

  eventLogger.log({
    event_type: EventType.action,
    engagement_type: 'search_price_button',
    feature: Features.PaidFlow,
    source_page: SourcePages.PaidLandingTest,
    event_context: {
      channel: 'paid',
    },
  });
}

export function trackPaidTextSearch(searchParams: Record<string, any>): void {
  googleAnalytics.event({
    category: 'paid_flow',
    action: 'search_text',
    label: `${Object.values(_.pickBy(searchParams, _.isString)).join(' ')}`,
  });

  eventLogger.log({
    event_type: EventType.action,
    engagement_type: 'search_text',
    feature: Features.PaidFlow,
    source_page: SourcePages.PaidLandingTest,
    event_context: {
      channel: 'paid',
    },
  });
}

export function UsedCarsWelcomePageViewEvent({ sourceUrl }: { sourceUrl?: string }): EventData {
  const eventData = {
    event_type: EventType.view,
    source_page: SourcePages.UsedCarsWelcome,
    view_type: ViewTypes.pageView,
    event_context: {},
  } as EventData;

  if (sourceUrl) eventData.event_context!.url = sourceUrl;

  return eventData;
}
